import CardExpiration from './card-expiration.vue';

export default CardExpiration;
